import {connect} from 'react-redux';
import ShiftListsScreen from '../../components/screens/ShiftListsScreen';

const ShiftListsScreenContainer = connect(
    null,
    null
)(ShiftListsScreen);

export default ShiftListsScreenContainer;